import { gql } from "@apollo/client";

export const REDIRECTS_QUERY = gql`
  query RedirectsQuery($limit: IntType!, $offset: IntType!) {
    redirects: allRedirects(first: $limit, skip: $offset) {
      source
      destination
    }
  }
`;
